export default __webpack_public_path__ + "static/media/p2.f58bb1c6.jpg";